import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import StudyPlanItem from '../../../../lcrp/components/StudyPlanItem'
import Clickable from '../../Clickable'

import { Row, Col } from 'react-bootstrap'

import panelStyle from 'Styles/panel.css'
import colors from 'Styles/baseColors.css'
import progressBarStyle from 'Styles/progress-bar.css'
import iconStyle from 'Styles/icon.css'
import style from './style.css'

import caretRight from 'Assets/caret-right-acqua.svg'
import caretDown from 'Assets/caret-down-acqua.svg'
import redDot from 'Assets/redDot.png'
import yellowDot from 'Assets/yellowDot.png'
import greenDot from 'Assets/greenDot.png'
import CustomProgressBar from '../../../../shared/components/CustomProgressBar'

export default class ProgressChart extends Component {
  constructor (props) {
    super(props)

    this.state = { showDetails: false }
    this.setDetailsState = this.setDetailsState.bind(this)
  }

  generatePieSlices (score) {
    let chartColor

    if (score < 70) {
      chartColor = colors.colorRedMacmillan
    } else if (score >= 70 && score < 90) {
      chartColor = colors.colorYellowMedium
    } else { // percentage >= 90
      chartColor = colors.colorGreenMedium
    }

    return (
      [
        {
          color: '#fff',
          value: 100 - score
        },
        {
          color: chartColor,
          value: score
        }
      ]
    )
  }

  renderTopics () {
    const topicItems = this.props.topics.map((topic, i) => {
      const hasQuestions = topic.totalQuestions > 0

      return (
        <StudyPlanItem
          key={topic.label}
          label={topic.label}
          totalPointsAvailable={this.props.totalPointsAvailable[i]}
          totalPointsEarned={this.props.totalPointsEarned[i]}
          hasQuestions={hasQuestions}
          disableLinks={true}
          isActive={true}
          fromLCRPInstructor={true}
        />
      )
    })
    return (
      <div>
        <Row>
          {topicItems}
        </Row>
      </div>
    )
  }

  renderAccuracyBar (score) {
    return (
      <CustomProgressBar
        dataTestId="averageAccuracyBar"
        className={classnames('progress', progressBarStyle.base, style.progressBar)}
        bsClass={classnames('progress-bar', style.progressBarValue)}
        ariaLabel={`You have ${score} points.`}
        now={score}
        min={0}
        max={100}
      />
    )
  }

  renderGradedDot (score) {
    if (score === 0 || isNaN(score)) {
      return '-- %'
    }
    let gradedDot = greenDot
    if (score < 70) {
      gradedDot = redDot
    } else if (score < 90) {
      gradedDot = yellowDot
    }
    return ([
      <img
        key={score}
        src={gradedDot}
        className={classnames(iconStyle.small, style.gradedDotImg)}
        alt={'graded dot'}
        tabIndex="-1"
      />,
      <label className={classnames(iconStyle.textIcon)}>{score}%</label>
    ])
  }

  setDetailsState (e) {
    this.setState({ showDetails: !this.state.showDetails })
  }

  render () {
    const {
      index,
      overallAccuracy,
      classPercentage,
      questionsReceived
    } = this.props
    const totalQuestionsReceived = questionsReceived
    const hrTick = (
      <div>
        <p className={style.hrLabel} style={{ left: (classPercentage - 8) + '%' }}>Class Avg.</p>
        <hr className={style.classAvgHr} style={{ left: classPercentage + '%' }} />
        <p className={style.hrPercent} style={{ left: (classPercentage - 2) + '%' }}>{classPercentage}%</p>
      </div>
    )

    return (
      <div key={index}>
        <div className={panelStyle.base}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Col xs={9} sm={9} className={style.chartLabels}>
              <p className={style.resultsLabel}>
                {index === 0
                  ? `Quiz Results (${totalQuestionsReceived} questions):`
                  : `Practice Retake ${index} (${totalQuestionsReceived} questions):`}
              </p>
              {this.props.showClassComparison ? hrTick : null}
              {this.renderAccuracyBar(overallAccuracy)}
            </Col>
            <Col xs={3} sm={3} style={{ paddingRight: '10px' }}>
              <div className={style.percentage}>
                <p className={style.accuracyDot}>Accuracy</p>
                {this.renderGradedDot(overallAccuracy)}
              </div>
            </Col>
          </div>
          <Clickable
            className={style.showRetakes}
            onClick={this.setDetailsState}
            data-test-id="topicPerformanceDetailBtn"
          >
            {this.state.showDetails
              ? <img aria-hidden="true" className={style.topicCaret} src={caretDown} alt={'caret expanded'} />
              : <img aria-hidden="true" className={style.topicCaret} src={caretRight} alt={'caret collapsed'} />
            }
            {this.state.showDetails ? 'Hide Topic Performance' : 'Show Topic Performance'}
          </Clickable>
          {this.state.showDetails ? this.renderTopics() : null}
        </div>
      </div>
    )
  }
}

ProgressChart.propTypes = {
  index: PropTypes.number,
  onCheckboxSelected: PropTypes.func,
  showClassComparison: PropTypes.bool,
  overallAccuracy: PropTypes.number,
  inProgressLabel: PropTypes.element,
  totalPointsEarned: PropTypes.array,
  totalPointsAvailable: PropTypes.array,
  topics: PropTypes.array,
  classPercentage: PropTypes.number,
  questionsReceived: PropTypes.number
}
